export default __webpack_public_path__ + "static/2-small-12f7e0f588f347b22077f22dd00d0e3a.jpg";